<!--<div class="resize-marker-container" [style.top]="reportSignature.top" [style.left]="reportSignature.left" [style.width]="reportSignature.width"
     [style.height]="reportSignature.height">

  <div *ngIf="reportSignature.isSelected" class="resize LT" [style.width]="getResizeMarkerSize()" [style.height]="getResizeMarkerSize()"
       [style.top]="getResizeMarkerTop('top')" [style.left]="getResizeMarkerLeft('left')" [style.zIndex]="reportSignature.zIndex + 1"
       (mousedown)="onResizeMarkerDown($event, 'top', 'left')" (mousemove)="onResizing($event)" (mouseup)="onResizeMarkerUp($event)"
       (mouseleave)="onResizeMarkerLeave($event)"></div>
  <div *ngIf="reportSignature.isSelected" class="resize CT" [style.width]="getResizeMarkerSize()" [style.height]="getResizeMarkerSize()"
       [style.top]="getResizeMarkerTop('top')" [style.left]="getResizeMarkerLeft('center')" [style.zIndex]="reportSignature.zIndex + 1"
       (mousedown)="onResizeMarkerDown($event, 'top', 'center')" (mousemove)="onResizing($event)" (mouseup)="onResizeMarkerUp($event)"
       (mouseleave)="onResizeMarkerLeave($event)"></div>
  <div *ngIf="reportSignature.isSelected" class="resize RT" [style.width]="getResizeMarkerSize()" [style.height]="getResizeMarkerSize()"
       [style.top]="getResizeMarkerTop('top')" [style.left]="getResizeMarkerLeft('right')" [style.zIndex]="reportSignature.zIndex + 1"
       (mousedown)="onResizeMarkerDown($event, 'top', 'right')" (mousemove)="onResizing($event)" (mouseup)="onResizeMarkerUp($event)"
       (mouseleave)="onResizeMarkerLeave($event)"></div>

  <div *ngIf="reportSignature.isSelected" class="resize LM" [style.width]="getResizeMarkerSize()" [style.height]="getResizeMarkerSize()"
       [style.top]="getResizeMarkerTop('middle')" [style.left]="getResizeMarkerLeft('left')" [style.zIndex]="reportSignature.zIndex + 1"
       (mousedown)="onResizeMarkerDown($event, 'middle', 'left')" (mousemove)="onResizing($event)" (mouseup)="onResizeMarkerUp($event)"
       (mouseleave)="onResizeMarkerLeave($event)"></div>
  <div *ngIf="reportSignature.isSelected" class="resize RM" [style.width]="getResizeMarkerSize()" [style.height]="getResizeMarkerSize()"
       [style.top]="getResizeMarkerTop('middle')" [style.left]="getResizeMarkerLeft('right')" [style.zIndex]="reportSignature.zIndex + 1"
       (mousedown)="onResizeMarkerDown($event, 'middle', 'right')" (mousemove)="onResizing($event)" (mouseup)="onResizeMarkerUp($event)"
       (mouseleave)="onResizeMarkerLeave($event)"></div>

  <div *ngIf="reportSignature.isSelected" class="resize LB" [style.width]="getResizeMarkerSize()" [style.height]="getResizeMarkerSize()"
       [style.top]="getResizeMarkerTop('bottom')" [style.left]="getResizeMarkerLeft('left')" [style.zIndex]="reportSignature.zIndex + 1"
       (mousedown)="onResizeMarkerDown($event, 'bottom', 'left')" (mousemove)="onResizing($event)" (mouseup)="onResizeMarkerUp($event)"
       (mouseleave)="onResizeMarkerLeave($event)"></div>
  <div *ngIf="reportSignature.isSelected" class="resize CB" [style.width]="getResizeMarkerSize()" [style.height]="getResizeMarkerSize()"
       [style.top]="getResizeMarkerTop('bottom')" [style.left]="getResizeMarkerLeft('center')" [style.zIndex]="reportSignature.zIndex + 1"
       (mousedown)="onResizeMarkerDown($event, 'bottom', 'center')" (mousemove)="onResizing($event)" (mouseup)="onResizeMarkerUp($event)"
       (mouseleave)="onResizeMarkerLeave($event)"></div>
  <div *ngIf="reportSignature.isSelected" class="resize RB" [style.width]="getResizeMarkerSize()" [style.height]="getResizeMarkerSize()"
       [style.top]="getResizeMarkerTop('bottom')" [style.left]="getResizeMarkerLeft('right')" [style.zIndex]="reportSignature.zIndex + 1"
       (mousedown)="onResizeMarkerDown($event, 'bottom', 'right')" (mousemove)="onResizing($event)" (mouseup)="onResizeMarkerUp($event)"
       (mouseleave)="onResizeMarkerLeave($event)"></div>
</div>-->

<div [ngClass]="{
    'report-signature': true,
    'selectable': reportSignature.isSelectable,
    'edited': !reportSignature.isSaved(),
    'selected': reportSignature.isSelected,
    'highlight-hover' : designService.highlightElement
  }"
     [style.top]="reportSignature.top" [style.left]="reportSignature.left" [style.width]="reportSignature.width" [style.height]="reportSignature.height"
     [style.zIndex]="reportSignature.zIndex" [style.borderWidth]="reportSignature.borderWidth+'mm'" [style.borderStyle]="reportSignature.borderStyle"
     [style.borderColor]="reportSignature.borderColor" (click)="onClick($event)"
     draggable="true" (dragstart)="onDragStart($event)" (dragover)="onDragOver($event)" (drop)="onDrop($event)">

  <div [style.padding]="'3mm'">
    <span>{{'reportSignature.signature' | translate}}</span>
  </div>
  <div [style.height]="'20mm'">
    <div [style.margin]="'3mm'" [style.height]="'16mm'"[style.borderBottom]="'1px solid black'" [style.float]="'right'"></div>
  </div>
  <div [style.padding]="'1mm 3mm'">
    <label [style.width]="'30mm'" [style.textAlign]="'center'">{{'reportSignature.name' | translate}}</label>
    <span>{{'reportSignature.Username' | translate}}</span>
  </div>
  <div [style.padding]="'1mm 3mm'">
    <label [style.width]="'30mm'" [style.textAlign]="'center'">{{'reportSignature.date' | translate}}</label>
    <span>{{'reportSignature.Currentdate' | translate}}</span>
  </div>
</div>

